export default function () {
  const forms = document.querySelectorAll('[data-validate]')

  forms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      const errorPlaceholder = form.querySelector('[data-validate-error]')
      errorPlaceholder?.classList.remove('is-visible')

      if (!(form as HTMLFormElement).checkValidity()) {
        e.preventDefault()
        errorPlaceholder?.classList.add('is-visible')
      }
    })
  })
}
